import { Forum } from '@mui/icons-material'
import { Box, Paper, Typography } from '@mui/material'

import useGetAgentCentralized from '~/features/agents/hooks/useGetAgentCentralized'
import usePartnerCentralized from '~/features/partners/hooks/usePartnerCentralized'
import { ESiteImagesTypes } from '~/features/partners/models'
import { getImgUrlByType } from '~/features/partners/utils'
import { EChatbotTheme } from '~/features/settings/models'
import { store } from '~/store'
import rem from '~/utils/ui'

type TProps = {
  chatNowHandler: () => void
}

function ChatNow({ chatNowHandler }: TProps) {
  const chatbotLayout = store((state) => state.chatbot.layout)
  const { selectedAgent } = useGetAgentCentralized()
  const { showLibby } = selectedAgent || {}
  const { partner } = usePartnerCentralized()
  const iconSrc = getImgUrlByType(ESiteImagesTypes.buttonIcon, partner)

  return (
    <Paper
      onClick={chatNowHandler}
      elevation={3}
      sx={{
        display: 'flex',
        maxWidth: 500,
        width: { xxxs: '100%', md: 500 },
        height: { xxxs: 64, md: 76 },
        borderRadius: 2,
        overflow: 'hidden',
        flexShrink: 0,
        cursor: 'pointer',
        '&:hover': {
          transform: 'scale(1.05)',
        },
        transition: 'all 0.3s ease-in-out',
      }}
    >
      <Box
        sx={{
          padding: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor:
            chatbotLayout.options[EChatbotTheme.linkView][
              chatbotLayout.selection[EChatbotTheme.linkView]
            ].accentColor,
          width: { xxxs: 48, md: 64 },
        }}
      >
        {showLibby ? (
          <Box
            component="img"
            src={iconSrc}
            alt="button icon"
            sx={{
              width: { xxxs: rem(40), sm: rem(50) },
            }}
          />
        ) : (
          <Forum
            fontSize="medium"
            sx={{
              color:
                chatbotLayout.options[EChatbotTheme.linkView][
                  chatbotLayout.selection[EChatbotTheme.linkView]
                ].buttonTextColor,
            }}
          />
        )}
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexGrow: 1,
          backgroundColor:
            chatbotLayout.options[EChatbotTheme.linkView][
              chatbotLayout.selection[EChatbotTheme.linkView]
            ].buttonColor,
        }}
      >
        <Typography
          variant="h5"
          color={
            chatbotLayout.options[EChatbotTheme.linkView][
              chatbotLayout.selection[EChatbotTheme.linkView]
            ].buttonTextColor
          }
        >
          Chat now!
        </Typography>
      </Box>
    </Paper>
  )
}

export default ChatNow
